import React, { useRef, useState } from 'react';
import styles from './HorizonaylCharts.module.css';

const HorizonaylCharts = ({ data = [], valueKey = 'value', dataKey = 'week' }) => {
  const containerRef = useRef(null);
  const [tooltip, setTooltip] = useState(null);

  if (!Array.isArray(data) || data.length === 0) return null;

  const step = Math.ceil(100 / 4);
  const listOfValues = Array.from({ length: 5 }, (_, i) => i * step);

  const showTooltip = (event, value, key, isCurrent) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left - 50;
    const y = event.clientY - rect.top + 50;

    setTooltip({ value, key, isCurrent, x, y });
  };

  const hideTooltip = () => setTooltip(null);

  return (
    <div className={styles.wrapper}>
      <div className={styles.chartContainer} ref={containerRef}>
        {data.map((item, index) => (
          <div
            key={index}
            className={styles.chartRow}
            onMouseMove={(e) => showTooltip(e, item[valueKey], item[dataKey], item.isCurrent)}
            onMouseLeave={hideTooltip}
          >
            <div className={styles.label}>
              <div
                className={`${styles.dot} ${item.isCurrent ? styles.activeDot : styles.inactiveDot}`}
              />
              <span className={`${styles.labelText} ${item.isCurrent ? styles.activeText : styles.inactiveText}`}>
                {item[dataKey]}
              </span>
            </div>
            <div className={styles.barTrack}>
              <div className={styles.barBackground} />
              <div
                className={`${styles.barFill} ${item.isCurrent ? styles.barActive : styles.barNormal}`}
                style={{ width: `${item[valueKey]}%` }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.axisLabels}>
        {listOfValues.map((v, i) => (
          <span key={i}>{v}%</span>
        ))}
      </div>

      {tooltip && (
        <div
          className={styles.tooltip}
          style={{ top: tooltip.y - 40, left: tooltip.x - 50 }}
        >
          <div
            className={styles.tooltipColor}
            style={{ backgroundColor: tooltip.isCurrent ? '#00B2FF' : '#6C22B5' }}
          />
          {tooltip.key}: {tooltip.value}
        </div>
      )}
    </div>
  );
};

export default HorizonaylCharts;
